export const progressbar = {
  value: {
    background: '{primary.color}',
  },
  label: {
    color: '{surface.0}',
  },
}
